/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 */

import getQueryParameters from './urlparser';
import NumberFormatter from '../cldr/number-formatter';

const formatters = {};

const displayLabelBlock = (formatterId, displayBlock, min, max) => {
  if (formatters[formatterId] === undefined) {
    displayBlock.text(
      displayBlock.text().replace(
        /([^\d]*)(?:[\d\s.,]+)([^\d]+)(?:[\d\s.,]+)(.*)/,
        `$1${min}$2${max}$3`,
      ),
    );
  } else {
    displayBlock.text(
      `${formatters[formatterId].format(min)} - ${formatters[formatterId].format(max)}`,
    );
  }
};

const updateInputsFromSlider = (sliderId, min, max) => {
  $(`#slider-input-min_${sliderId}`).val(min);
  $(`#slider-input-max_${sliderId}`).val(max);
};

const getInputValues = (sliderId) => {
  const sliderEl = $(`#slider-range_${sliderId}`);
  const sliderMin = sliderEl.slider('option', 'min');
  const sliderMax = sliderEl.slider('option', 'max');

  let minVal = parseInt($(`#slider-input-min_${sliderId}`).val(), 10);
  let maxVal = parseInt($(`#slider-input-max_${sliderId}`).val(), 10);

  if (isNaN(minVal)) minVal = sliderMin;
  if (isNaN(maxVal)) maxVal = sliderMax;

  minVal = Math.max(sliderMin, Math.min(minVal, sliderMax));
  maxVal = Math.max(sliderMin, Math.min(maxVal, sliderMax));

  if (minVal > maxVal) {
    const tmp = minVal;
    minVal = maxVal;
    maxVal = tmp;
  }

  return {minVal, maxVal};
};

const syncSliderFromInput = (sliderId) => {
  const {minVal, maxVal} = getInputValues(sliderId);
  const sliderEl = $(`#slider-range_${sliderId}`);

  sliderEl.slider('values', [minVal, maxVal]);

  displayLabelBlock(
    sliderId,
    $(`#facet_label_${sliderId}`),
    minVal,
    maxVal,
  );
};

const triggerSliderFromInput = (sliderId) => {
  const {minVal, maxVal} = getInputValues(sliderId);
  const sliderEl = $(`#slider-range_${sliderId}`);

  sliderEl.slider('values', [minVal, maxVal]);

  displayLabelBlock(
    sliderId,
    $(`#facet_label_${sliderId}`),
    minVal,
    maxVal,
  );
  updateInputsFromSlider(sliderId, minVal, maxVal);

  // Trigger facet update
  const facetEl = $(`#facet_${sliderId}`);
  const nextEncodedFacetsURL = facetEl.data('slider-encoded-url');
  const urlsSplitted = nextEncodedFacetsURL.split('?');
  let queryParams = [];

  if (urlsSplitted.length > 1) {
    queryParams = getQueryParameters(urlsSplitted[1]);
  }

  let found = false;
  queryParams.forEach((query) => {
    if (query.name === 'q') {
      found = true;
    }
  });

  if (!found) {
    queryParams.push({name: 'q', value: ''});
  }

  queryParams.forEach((query) => {
    if (query.name === 'q') {
      query.value += [
        query.value.length > 0 ? '/' : '',
        facetEl.data('slider-label'),
        '-',
        facetEl.data('slider-unit'),
        '-',
        minVal,
        '-',
        maxVal,
      ].join('');
    }
  });

  const requestUrl = [
    urlsSplitted[0],
    '?',
    $.param(queryParams),
  ].join('');

  prestashop.emit('updateFacets', requestUrl);
};

/**
 * Refresh facets sliders
 */
const refreshSliders = () => {
  $('.faceted-slider').each(function initializeSliders() {
    const $el = $(this);
    const values = $el.data('slider-values');
    const specifications = $el.data('slider-specifications');
    const sliderId = $el.data('slider-id');

    if (specifications !== null && specifications !== undefined) {
      formatters[sliderId] = NumberFormatter.build(specifications);
    }

    const currentMin = values === null ? $el.data('slider-min') : values[0];
    const currentMax = values === null ? $el.data('slider-max') : values[1];

    displayLabelBlock(
      sliderId,
      $(`#facet_label_${sliderId}`),
      currentMin,
      currentMax,
    );

    updateInputsFromSlider(sliderId, currentMin, currentMax);

    $(`#slider-range_${sliderId}`).slider({
      range: true,
      min: $el.data('slider-min'),
      max: $el.data('slider-max'),
      values: [currentMin, currentMax],
      stop(event, ui) {
        const nextEncodedFacetsURL = $el.data('slider-encoded-url');
        const urlsSplitted = nextEncodedFacetsURL.split('?');
        let queryParams = [];

        // Retrieve parameters if exists
        if (urlsSplitted.length > 1) {
          queryParams = getQueryParameters(urlsSplitted[1]);
        }

        let found = false;
        queryParams.forEach((query) => {
          if (query.name === 'q') {
            found = true;
          }
        });

        if (!found) {
          queryParams.push({name: 'q', value: ''});
        }

        // Update query parameter
        queryParams.forEach((query) => {
          if (query.name === 'q') {
            // eslint-disable-next-line
            query.value += [
              query.value.length > 0 ? '/' : '',
              $el.data('slider-label'),
              '-',
              $el.data('slider-unit'),
              '-',
              ui.values[0],
              '-',
              ui.values[1],
            ].join('');
          }
        });

        const requestUrl = [
          urlsSplitted[0],
          '?',
          $.param(queryParams),
        ].join('');

        prestashop.emit(
          'updateFacets',
          requestUrl,
        );
      },
      slide(event, ui) {
        displayLabelBlock(
          sliderId,
          $(`#facet_label_${sliderId}`),
          ui.values[0],
          ui.values[1],
        );
        updateInputsFromSlider(sliderId, ui.values[0], ui.values[1]);
      },
    });
  });

  // Real-time sync: update slider position as user types
  $(document).off('input.sliderInput').on('input.sliderInput', '.slider-input', function handleInputLive() {
    const sliderId = $(this).data('slider-id');
    syncSliderFromInput(sliderId);
  });

  // On change (blur / Enter): trigger the actual facet filter update
  $(document).off('change.sliderInput').on('change.sliderInput', '.slider-input', function handleInputChange() {
    const sliderId = $(this).data('slider-id');
    triggerSliderFromInput(sliderId);
  });
};

export default refreshSliders;
